/* eslint-disable eqeqeq */
import React,{useState,useCallback,useEffect}from 'react';
import ReactEcharts from 'echarts-for-react';
import { Button,WingBlank,DatePicker, List ,Accordion } from 'antd-mobile';
import {connect} from 'dva';

function formatDateYear(date)
{
    const dateStr = `${date.getFullYear()}`;
        return dateStr;
}
function getPosition(){
    let height = window.screen.height-150;
    let width = window.screen.width;

    return {height: height+'px', 
             width: width +'px'};
}
function getOtion(monthTj)
    {
        
        let option = {
            title:{
                text:'月用货量，单位元'
            },
            color: ['#3398DB'],
            tooltip : {
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            yAxis : [
                {
                    type : 'category',
                    data : ['一月', '二月', '三月', '四月', '五月', '六月', '七月','八月','九月','十月','十一月','十二月'],
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            xAxis : [
                {
                    type : 'value'
                }
            ],
            series : [
                {
                    name:'用货量',
                    type:'bar',
                    barWidth: '90%',
                    label: {
                        normal: {
                            show: true,
                            position: 'inside'
                        }
                    },
                    data:[ monthTj[0].AAF013,
                           monthTj[1].AAF013,
                           monthTj[2].AAF013,
                           monthTj[3].AAF013,
                           monthTj[4].AAF013,
                           monthTj[5].AAF013,
                           monthTj[6].AAF013,
                           monthTj[7].AAF013,
                           monthTj[8].AAF013,
                           monthTj[9].AAF013,
                           monthTj[10].AAF013,
                           monthTj[11].AAF013,
                         ]
                }
            ]
        };
        return option;
    }
function ZdrCusMonthTj(props)
{
    let [year,setYear] = useState(new Date());
    // eslint-disable-next-line no-unused-vars
    let [monthTj,setMonthTj] = useState(
           [{AAF008: "1", AAF013: "0.00"},
            {AAF008: "2", AAF013: "0.00"},
            {AAF008: "3", AAF013: "0.00"},
            {AAF008: "4", AAF013: "0.00"},
            {AAF008: "5", AAF013: "0.00"},
            {AAF008: "6", AAF013: "0.00"},
            {AAF008: "7", AAF013: "0.00"},
            {AAF008: "8", AAF013: "0.00"},
            {AAF008: "9", AAF013: "0.00"},
            {AAF008: "10", AAF013: "0.00"},
            {AAF008: "11", AAF013: "0.00"},
            {AAF008: "12", AAF013: "0.00"}]);
    useEffect(()=>{
        if(props.AAE002=='')
        {
            props.dispatch({type:"index/changeRouter",payload:{
                route : '/home',
            }});
        }else{
            props.dispatch({type:"echart/getZdrCusMonthTj",payload:{
                in_AAA001 : localStorage.getItem("AAA001"),
                in_AAE002 : props.AAE002,
                in_AAC002 : localStorage.getItem("AAC002"),
                in_AAF008 : formatDateYear(year)
            }}).then((res)=>{
                setMonthTj(res);
            });
        }
        

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[year]);

    let handdleSelectYear = useCallback((year)=>{
        setYear(year);
        props.dispatch({type:"echart/getZdrCusMonthTj",payload:{
            in_AAA001 : localStorage.getItem("AAA001"),
            in_AAE002 : props.AAE002,
            in_AAC002 : localStorage.getItem("AAC002"),
            in_AAF008 : formatDateYear(year)
        }}).then((res)=>{
            setMonthTj(res);
        });
    },[props]);

    let handlesubmit=useCallback(()=>{
        props.dispatch({type:"index/changeRouter",payload:{
          route:"/orderingPrrson"
        }});
     },[props]);

    return (
        <div >
        <WingBlank className="fullScreen">
            <DatePicker
            mode="year"
            title="选择年度"
            format={(date)=> formatDateYear(date)}
            extra="请先选择年度查看数据"
            value={year}
            onChange={year => handdleSelectYear(year)}
            >
            <List.Item arrow="horizontal">年度</List.Item>
            </DatePicker>
        
        </WingBlank >
        <br/>
        <br/>
        <br/>
        <WingBlank>
        <ReactEcharts option={getOtion(monthTj)}style={{...getPosition()}}className='react_for_echarts' />
        </WingBlank>
        <Accordion defaultActiveKey="0" style={{right:0, bottom:0, maxHeight:400 , position:'fixed',zIndex:10}}>
          <Accordion.Panel header={props.AAE004}>
          <Button type="primary" size="small" loading={props.loading} disabled={props.loading} onClick={handlesubmit} >返回</Button>
          </Accordion.Panel>
    </Accordion>
        </div>
    );
}

export default connect(state=>{
    return{
        ...state.echart
    }
})(ZdrCusMonthTj) ;